import * as React from 'react'
import { lighten, darken } from '@mui/material/styles'
import MuiAvatar from '@mui/material/Avatar'

const COLORS = [
  '#d84315', // red
  '#ffd600', // yellow
  '#fb8c00', // orange
  '#00c853', // green
  '#0091ea', // light blue
  '#00838f', // teal
  '#b388ff', // purple
  '#c51162', // magenta
  '#607d8b', // blue-grey
  '#ba68c8', // purplish
  '#aa00ff', // bright purple
  '#00bcd4', // cyan
  '#cddc39', // lime
]

export const stringToColor = (hash) => {
  var number = 0.0;
  for(let i=0;i<hash.length;i++) {
      number += parseInt(hash.charCodeAt(i), 16);
  }
  const idx = number % COLORS.length;
  return COLORS[idx];
}

const nameToInitials = (name) => {
  if (name.split(' ').length === 1) {
    return `${name[0]}`.toUpperCase()
  }
  return `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`.toUpperCase()
}

export const Avatar = ({ name, icon, sx, ...props }) => {
  //console.log('Avatar', name, icon, sx)
  const color = stringToColor(name)
  return (
    <MuiAvatar
      sx={{
        bgcolor: lighten(color, 0.7),
        color: darken(color, 0.5),
        ...sx
      }}
      {...props}
    >
      {icon ? icon : nameToInitials(name)}
    </MuiAvatar>
  )
}

export default Avatar
